import { queryCmsData, queryConfigure } from '@/api/travelConfigure'
import { cookies, getCityId, getCityNameByCityId, getPosition } from '@/utils'
import { isApp, getHeaderHeight } from 'kwsdk'
import { Toast } from 'vant'

export enum TemplateTypeEnum {
  Textarea = 1,
  Text,
  Radio,
  Checkbox,
  Select,
  Date
}

export type TemplateType = {
  id: number
  templateKey: string
  templateName: string
  templateType: TemplateTypeEnum
}

export type TemplatePriceType = {
  id: number
  maxPrice: number
  minPrice: number
  priceDesc: string
}

export type TravelConfigureType = {
  backgroundColor: string
  backgroundImage: string
  title: string
  priceList: TemplatePriceType[]
  templateList: TemplateType[]
}

type FormDataType = Partial<{
  cityId: string
  travelCount: string
  remark: string
  travelTime: string
  travelDays: string
  desiredPrice: TemplatePriceType | null
  [templateKey: string]: any
}>

export type StateType = {
  setId: string
  cityId: string
  cityName: string
  statusBarHeight: number
  navHeight: number
  navigationBarShowed: boolean
  configureData: TravelConfigureType | null
  cmsData: { destinationTip: string } | null
  formData: FormDataType
  storageFormData: FormDataType
}

const { statusBarHeight = 0 } = getHeaderHeight() || {}
const navHeight = 44
const storageFormData = JSON.parse(localStorage.getItem('formData') || '{}')
localStorage.removeItem('formData')

export default {
  namespaced: true,
  state: (): StateType => ({
    setId: '',
    cityId: '',
    cityName: '',
    statusBarHeight,
    navHeight,
    navigationBarShowed:
      isApp && window.localjs && window.localjs.setHeaderVisible,
    configureData: null,
    cmsData: null,
    formData: {}, //最终提交的表单数据
    storageFormData //缓存的表单数据
  }),
  mutations: {},
  getters: {
    departureTempalte(state: StateType) {
      return state.configureData?.templateList.find(
        template => template.templateKey == 'cityId'
      )
    },
    destinationTempalte(state: StateType) {
      return state.configureData?.templateList.find(
        template => template.templateKey == 'travelCity'
      )
    }
  },
  actions: {
    async initTravelConfigure({ state }: { state: StateType }) {
      try {
        if (state.setId) {
          state.configureData = await queryConfigure(state.setId)
        }
      } catch (error: any) {
        console.error(error)
        Toast(error?.msg || '网络错误')
      }
    },
    async initCmsData({ state }: { state: StateType }) {
      try {
        state.cmsData = await queryCmsData()
      } catch (error: any) {
        console.error(error)
      }
    },
    async initCityInfo({ state }: { state: StateType }) {
      let cityId = ''
      let cityName = ''
      const cookieCityCode = cookies.get('city') || cookies.get('citycode')
      if (cookieCityCode) {
        cityId = getCityId(cookieCityCode.split('_')[0])
        cityName = (
          decodeURIComponent(cookieCityCode.split('_')[1] || '') ||
          (await getCityNameByCityId(cityId))
        ).replace('市', '')
      } else {
        const postion = await getPosition(false)
        if (postion) {
          cityId = postion.cityId
          cityName = postion.cityName.replace('市', '')
        }
      }
      if (cityId && cityName) {
        state.cityId = cityId
        state.cityName = cityName
      }
    }
  }
}
